import { type RootState } from '@/store';
// `AuthProvider` comes from its defining module rather than the
// `@/models/authModel` re-export, for the reason recorded on the same import in
// `@/hooks/query/useQueryKindeProperties`: pulling the auth model in for a plain
// enum makes `authModel` initialise before `@/store` and trips the pre-existing
// `authModel` <-> `store` cycle with a TDZ ReferenceError. Only import sort
// order was hiding it here too.
import { AuthProvider } from '@/utils/auth/persistedAuthProvider';
import { useSelector } from 'react-redux';

export const useIsFhirAuth = (): boolean => {
  const authProvider = useSelector((state: RootState) => state.auth.authProvider);
  return authProvider === AuthProvider.FHIR;
};
